export default __webpack_public_path__ + "static/media/aphroditeLogo.21fe8b28.png";